<template>
  <div id="app" style="min-width: 950px;">
    <!-- 头部 -->
    <top-header></top-header>
    <!-- 路由视图 -->
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
    <!-- 底部 -->
    <div class="footer-box">
      <img src="../src/assets/images/qianjia.png" alt="">
      <div>千家网络科技技术支持</div>
    </div>
  </div>
</template>

<script>
// 头部组件引入
import TopHeader from "./components/Header.vue";
export default {
  name: 'App',
  components: {
    TopHeader
  }
}
</script>
<style lang="scss">
@import "@/style/index.scss";
.footer-box {
  color: #5c5c5c;
  padding: 20px 0;
  background-color: #f7f7f7;
  display: flex;
  justify-content: center;
  align-items: center;
  
  img {
    width: 50px;
    margin-left: 10px;
  }
  div {
    font-size: 12px;
    margin: 5px 0 0 10px;
  }
}
</style>





// WEBPACK FOOTER //
// examples/App.vue